import { Id } from 'src/types'

export enum BedroomsOfferActionTypes {
  GET_BEDROOMS_OFFER = '@bedroomsOffer/GET_BEDROOMS_OFFER',
  GET_BEDROOMS_OFFER_FAILURE = '@bedroomsOffer/GET_BEDROOMS_OFFER_FAILURE',
  GET_BEDROOMS_OFFER_SUCCESS = '@bedroomsOffer/GET_BEDROOMS_OFFER_SUCCESS',
  SEND_BEDROOMS_OFFER = '@bedroomsOffer/SEND_BEDROOMS_OFFER',
  SEND_BEDROOMS_OFFER_FAILURE = '@bedroomsOffer/SEND_BEDROOMS_OFFER_FAILURE',
  SEND_BEDROOMS_OFFER_SUCCESS = '@bedroomsOffer/SEND_BEDROOMS_OFFER_SUCCESS'
}

export type ResponseDataRequests = {
  agency_partner_hotel_offers: ResponseDataRequestsItem[]
}

export interface ResponseDataRequestsItem {
  partner_hotel_room_offer_id: number
  agency_partner_hotel_offer_id: number
  partner_hotel_room_id: number
  start_date: string
  end_date: string
  pension: boolean
  fare_value: number
  tax_value: number
  description: string
  active: boolean
  agency_partner: {
    agency_partner_id: Id
    partner_id: Id
    description: string
    active: boolean
  }
  agency_partner_hotel_agreement: {
    agency_partner_hotel_agreement_id: Id
    agency_partner_hotel_offer_id: Id
    agreement: {
      agreement_id: Id
      organization_id: Id
      service_hub_id: Id
      agreement_type: string
      integration_type: string
      name: string
      code: string
    }
  }
}

export type ResponseDataRequestTotals = {
  request_totals: {
    total_emissions: number
    total_quotations: number
  }
}

export type BedroomsOfferState = ResponseDataRequestTotals & {
  readonly error: string
  readonly list: ResponseDataRequestsItem[]
  readonly loading: boolean
  readonly sendBedroomsOfferError: string
  readonly sendBedroomsOfferLoading: boolean
  readonly total_results: number
}
